import LRKeenSlider from "./component/LRKeenSlider";
import {selectors} from "./Constants";

(() => {
  let sliders: NodeListOf<HTMLElement> = document.querySelectorAll(selectors.keenSlider.el);

  if (sliders.length) {
    for (let i = 0; i < sliders.length; i++) {
      new LRKeenSlider(sliders[i]);
    }
  }
})();
